// extracted by mini-css-extract-plugin
export var csatScore = "_jk-5";
export var header = "_jk-1";
export var panelWrapper = "_jk-2";
export var postPreview = "_jk-3";
export var rightContent = "_jk-0";
export var wrappingText = "_jk-4";